import http from '@/utils/http';

// 学校列表
export const schoolList = () => {
    return http({
        url: '/api/rongai/v2/school/list',
    });
};
// 学生列表
export const studentList = (params) => {
    return http({
        url: '/api/rongai/v2/student/list',
        params
    });
};


// 增加班级
export const addClass = (data) => {
    return http({
        url: '/api/rongai/v2/classInfo',
        method: "post",
        data
    })
}
// 添加学生
export const addStudent = (data) => {
    return http({
        url: '/api/rongai/v2/student',
        method: "post",
        data
    })
}

// 查询班级信息
export const classInfo = (params) => {
    return http({
        url: '/api/rongai/v2/classInfo/list',
        method: "get",
        params
    })
}
//删除学生
export const deleteStudent = (params) => {
    return http({
        url: '/api/rongai/v2/student',
        method: "delete",
        params
    })
}

// 修改学生信息
export const updaStudent = (data) => {
    return http({
        url: '/api/rongai/v2/student',
        method: 'put',
        data
    });
};















